import { createPayloadAction } from 'helpers/actionsHelpers'
import { PayloadAction } from 'interfaces/action'
import { WithPushNotificationsPlayerId } from 'interfaces/pushNotifications'

type SetPushNotificationsPlayerIdPayload =
  & WithPushNotificationsPlayerId
export const SET_PUSH_NOTIFICATIONS_PLAYER_ID = 'SET_PUSH_NOTIFICATIONS_PLAYER_ID' as const
export const setPushNotificationsPlayerIdActionCreator = (payload: SetPushNotificationsPlayerIdPayload): PayloadAction<typeof SET_PUSH_NOTIFICATIONS_PLAYER_ID, SetPushNotificationsPlayerIdPayload> => createPayloadAction(SET_PUSH_NOTIFICATIONS_PLAYER_ID, payload)
type SetPushNotificationsPlayerId = ReturnType<typeof setPushNotificationsPlayerIdActionCreator>

export type PushNotificationsAction =
  | SetPushNotificationsPlayerId
